export default __webpack_public_path__ + "static/media/am.bf875297.svg";